import { createFileRoute } from "@tanstack/react-router";
import ListingsV2Demo from "@/pages/ListingsV2Demo";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/listings-v2-demo/")({
  head: () => routeHead("/listings-v2-demo/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ListingsV2Demo />
  );
}
